import { jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text, Link, colors } from '@aftersale-next/ui';
import endpoints from '../config/endpoints';
export var PolicyTerms = function PolicyTerms() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(Text, {
    color: colors.textForeground,
    center: true,
    size: "10px",
    children: [t('POLICY_TERMS_MESSAGE'), "\xA0", /*#__PURE__*/_jsxs(Link, {
      size: "10px",
      href: endpoints.policy,
      rel: "noopener noreferrer",
      target: "_blank",
      children: [t('USE_TERMS_LABEL'), " ", t('AND'), " ", t('POLICY_TERMS_LABEL')]
    })]
  });
};
export default PolicyTerms;